import { render } from "./SectionSidebarItem.vue?vue&type=template&id=d9c45536"
import script from "./SectionSidebarItem.vue?vue&type=script&lang=js"
export * from "./SectionSidebarItem.vue?vue&type=script&lang=js"

import "../styles/SectionSidebarItem.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__